import { ISorter, ISorterConfig } from 'pbc.types';

export interface IBesichtigungenQuerySorter extends ISorter {}

export const BesichtigungenQuerySorterConfig: ISorterConfig = [];
